'use client';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  SafeImage,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  Text,
} from '@/ui';
import { SelectValue } from '@radix-ui/react-select';
import { Place } from '@types';
import { UseFormReturn } from 'react-hook-form';

export const AtreemoFormPlaceSelector = ({
  places,
  form,
  currentPlace,
}: {
  places: Place[];
  form: UseFormReturn;
  currentPlace: Place | undefined;
}) => (
  <>
    {places.length > 1 && (
      <FormField
        key={'SelectedLocationID'}
        name="SelectedLocationID"
        control={form.control}
        render={({ field }) => (
          <FormItem>
            <FormLabel>Preferred Location *</FormLabel>
            <FormControl>
              <Select value={field.value} onValueChange={field.onChange}>
                <SelectTrigger>
                  <SelectValue placeholder="Select your local" />
                </SelectTrigger>
                <SelectContent>
                  {places.map(({ apps, name }) => (
                    <SelectItem key={name} value={apps.atreemo.id}>
                      {name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </FormControl>
          </FormItem>
        )}
      />
    )}

    {form.getValues('SelectedLocationID') && (
      <div className="flex flex-col gap-2">
        <FormLabel>You&apos;ll receive updates from</FormLabel>
        <div className="bg-card border-border flex items-center overflow-hidden rounded-lg border">
          <div className="relative flex size-20">
            <SafeImage
              src={currentPlace?.default?.images?.primaryImage}
              alt=""
              fill
              sizes="96px"
              className="object-cover"
            />
          </div>
          <div className="flex flex-col p-4">
            <Text element="h5">{currentPlace?.name}</Text>
            <Text element="span" className="text-muted-foreground">
              {currentPlace?.default.address.addressLine1}, {currentPlace?.default.address.cityOrTown}
            </Text>
          </div>
        </div>
      </div>
    )}
  </>
);
